import { atom } from 'recoil'

export default atom({
  key: 'mapInteractions',
  default: { show: false, edit: false, select: false, remove: false }
})
